import {HOST_API} from 'src/config-global';

const COMMENT_SAVE_API_URI = '/api/comment/save';

export async function saveComment({commentId = null, replyToCommentId = null, recipeId, content}) {
  const method = commentId ? 'PUT' : 'POST';
  const response = await fetch(`${HOST_API}${COMMENT_SAVE_API_URI}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
    },
    body: JSON.stringify({replyTo: replyToCommentId, recipeId, content})
  });

  if (!response.ok) {
    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }

    throw new Error(message);
  }

  return response.json();
}

